import { t } from 'i18n';
import React from 'react';
import { Button, LazyImage, Flex, Shape, styled } from '@teko/ds-desktop';
import { useRouter } from 'next/router';

export const EmptyCartPanel = ({ ...props }) => {
  const router = useRouter();
  return (
    <Flex
      backgroundColor="white"
      borderRadius="m"
      direction="column"
      justify="center"
      align="center"
      padding="s32"
      {...props}
    >
      <LazyImage src="https://shopfront-cdn.tekoapis.com/static/empty_cart.png" />
      <Description marginTop="s16" marginBottom="s24">
        {t('Giỏ hàng chưa có sản phẩm nào')}
      </Description>
      <Button
        variant="primary"
        size="m"
        onClick={() => router.push('/')}
        className="buy-now"
      >
        {t('Mua sắm ngay')}
      </Button>
    </Flex>
  );
};

const Description = styled(Shape)`
  color: ${({ theme }) => theme.colors.neutral};
`;
